export default "__VITE_ASSET__3wWkS_nz__"